// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FiltersMenu_wrapper__1POqU","menu":"FiltersMenu_menu__XW0bj","backButton":"FiltersMenu_backButton__2MwN4"};